import type { NextPage } from 'next'
import { SignupSuccess } from '@/client/modules/SignupSuccess'
import { SignupSuccessProps } from '@/client/modules/SignupSuccess/types'
import { getCMSContent } from '@/client/utils'

const SignupSuccessPage: NextPage<SignupSuccessProps> = (data) => <SignupSuccess {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'SIGNUP_SUCCESS')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default SignupSuccessPage
